import { render } from "./LoaderMessage.vue?vue&type=template&id=5a77b9f8&scoped=true"
import script from "./LoaderMessage.vue?vue&type=script&lang=js"
export * from "./LoaderMessage.vue?vue&type=script&lang=js"

import "./LoaderMessage.vue?vue&type=style&index=0&id=5a77b9f8&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a77b9f8"]])

export default __exports__